/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Async state management selectors
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { IAsyncStateManagementReducer } from './asyncStateManagementReducer';

export const getAsyncStateManagementState = (state: IRootReducer) => state.asyncStateManagement;

type TActiveLoadedStatus = IAsyncStateManagementReducer['isLoaded'];
export const makeSelectAsyncStateManagementIsLoaded = ():
    OutputSelector<IRootReducer, TActiveLoadedStatus, (state: IAsyncStateManagementReducer) => TActiveLoadedStatus> =>
    createSelector(
        getAsyncStateManagementState,
        (state: IAsyncStateManagementReducer) => state.isLoaded,
    );

type TActiveSaga = IAsyncStateManagementReducer['activeSagasTask'];
export const makeSelectAsyncStateManagementActiveSagas = ():
    OutputSelector<IRootReducer, TActiveSaga, (state: IAsyncStateManagementReducer) => TActiveSaga> =>
    createSelector(
        getAsyncStateManagementState,
        (state: IAsyncStateManagementReducer) => state.activeSagasTask,
    );
